import { endpoints } from '.'
import { executeHttp, HttpResponse } from './http'
import { Headers } from './utils'

export interface Highlight {
    from: number
    to: number
    duration: number
}
export interface HighlightsResponse {
    highlights: Highlight[]
}

export const getTrackHighlights = async (
    trackId: string,
    accessToken?: string
): Promise<HttpResponse<HighlightsResponse>> => {
    const headers = {
        [Headers.Authorization]: `Bearer ${accessToken}`,
    }

    const data = await executeHttp<HighlightsResponse>(
        {
            endpoint: endpoints.internal.v0.getTrackHighlights,
            pathParams: { trackId },
            ...(accessToken && { headers: headers }),
        },
        true
    )

    if (data.data && !Array.isArray(data.data.highlights)) {
        throw new Error(
            'Invalid data format received from portal highlights API'
        )
    }

    return data
}
